export default {
  // home

  // ui
  entrar: "Entrar",
  play: "Reproducir",
  pause: "Pausar",
  subtitles: "Subtítulos",
  pantalla_completa: "Pantalla completa",
  salir_pantalla_completa: "Salir de pantalla completa",
  escena_completada: "Escena completada",
  // overlays
  r1_1: "A) Sí, son coberturas que se contratan aparte de la póliza básica.",
  r1_2: "B) No, un seguro de hogar suele cubrir daños por agua, incendio, robo y responsabilidad civil.",
  r1_3: "C) Sí, van incluidas en cualquier póliza de hogar estándar.",
  r2_1: "A) Se va multiplicando solo, porque cuanto más tiempo pasa sin que nadie lo toque, más crece.",
  r2_2: "B) Ni crece ni deja de crecer, porque estar quieto no le hace nada.",
  r2_3: "C) Quieto no crece. De hecho, pierde valor. Para que genere algo tiene que estar puesto en algún sitio que lo haga trabajar.",
  r3_1: "A) La vivienda y todo lo que hay dentro, porque el seguro calcula automáticamente lo que compras, guardas o tiras cada día.",
  r3_2: "B) La vivienda y lo que hay dentro, aunque se debe declarar el valor del contenido.",
  r3_3: "C) Lo que hay dentro; la vivienda ya queda cubierta por el banco al conceder la hipoteca.",

};
